export default __webpack_public_path__ + "static/media/team56.e5d06c36.JPG";